// AIR-12 | New PDP: old top section (v1) vs new top section (control)
//
// Assignment and the visual switch happen earlier, in <head>: snippets/air-12-pdp-top.liquid
// (it has to run before the page draws, so there's no flicker). That snippet sets the ab_AIR12
// cookie and window.AIR12. This file only reports the assignment to GA4, in the same format as
// the manual A/B script (AIR-11 v2). Preview mode and targeting are configured in the snippet.
//
// Wrapped in its own function scope: ad-10.js (loaded on every product page) also declares
// top-level `const iframe` / `realLog`, and top-level consts are shared across all scripts, so a
// second declaration stopped this whole file with a SyntaxError (no GA4 reporting).
//
// BOGOS free-gift box ("Buy X, Get Y"): the BOGOS app embed injects one box per page, into the
// first add-to-cart form it finds, which is the old top's (even while it's hidden). So:
//   - everyone not in v1: the box is moved into the new top's form, where it sits on live.
//   - v1 (testCode): the box stays in the old top, restyled for its dark background: white text,
//     a "Buy X5 Gen 2, Get a FREE SF3 Fan" title built from the product and gift names, and the
//     quantity on its own row above the box (desktop; mobile already stacks).
// The gift itself is added by BOGOS at the cart either way; this is only the box on the page.
(function () {

// 1. Create an invisible iframe to bypass the theme's silencer
const iframe = document.createElement('iframe');
iframe.style.display = 'none';
document.body.appendChild(iframe);

// 2. Steal its untouched console.log and warn functions
const realLog = iframe.contentWindow.console.log;
const realWarn = iframe.contentWindow.console.warn;

window.gbEvents = window.gbEvents || [];

const OLD_TOP = '[data-pdp-top-classic]';
const GIFT_BOX = '#sca-gift-thumbnail';

// Control / preview: put the BOGOS box back in the new top's form, right before Add to Cart
// (where BOGOS puts it on live). Runs again whenever BOGOS (re)inserts the box.
function placeGiftBoxInNewTop() {
	const box = document.querySelector(`${OLD_TOP} ${GIFT_BOX}`);
	if (!box) return;
	const form = document.querySelector('airdog-product form[action*="/cart/add"]');
	const button = form && form.querySelector('button[type="submit"]');
	if (!button) return;
	const previous = form.querySelector(GIFT_BOX);
	if (previous) previous.remove();
	form.classList.add('sca-fg-form-thumbnail-product-page');
	button.before(box);
}

// "Airdog X5 Air Purifier GEN 2" -> "X5 Gen 2"
function shortProductName(title) {
	return title
		.replace(/^\s*Airdog\s+/i, '')
		.replace(/\s+Air Purifier\b/i, '')
		.replace(/\bGEN\b/, 'Gen')
		.replace(/\s+/g, ' ')
		.trim();
}

// Model code + type, as the client names offers: "Airdog Smart Circulating Fan SF3" -> "SF3 Fan",
// "MOI Mold-Free Evaporative Humidifier" -> "MOI Humidifier". Otherwise the name without "Airdog".
function shortGiftName(name) {
	const clean = name.replace(/^\s*Airdog\s+/i, '').replace(/\s+/g, ' ').trim();
	const words = clean.split(' ');
	const model = words.find((word) => /^[A-Z][A-Z0-9]+$/.test(word));
	const type = words.find((word) => /^(Fan|Purifier|Humidifier)$/i.test(word));
	return model && type ? `${model} ${type}` : clean;
}

function setGiftBoxTitle() {
	const title = document.querySelector(`${OLD_TOP} ${GIFT_BOX} .fg-gift-thumbnail-offer-title`);
	const heading = document.querySelector(`${OLD_TOP} h1`);
	const gifts = [...document.querySelectorAll(`${OLD_TOP} ${GIFT_BOX} .fg-gift-image`)]
		.map((img) => shortGiftName(img.alt || ''))
		.filter(Boolean);
	if (!title || !heading || !gifts.length) return;
	const text = `Buy ${shortProductName(heading.textContent)}, Get a FREE ${[...new Set(gifts)].join(' + ')}`;
	if (title.textContent !== text) title.textContent = text;
}

function styleOldTopGiftBox() {
	const style = document.createElement('style');
	style.textContent = `
		${OLD_TOP} ${GIFT_BOX} { --bogos-gt-offer-name: #fff; }
		${OLD_TOP} ${GIFT_BOX} .fg-gift-thumbnail-offer-title,
		${OLD_TOP} ${GIFT_BOX} .fg-gift-thumbnail-offer-footer-quantity { color: #fff !important; }
		@media screen and (min-width: 750px) {
			${OLD_TOP} .product-form__quantity { flex-direction: column; }
			${OLD_TOP} .product-form__quantity > .quantity-custom-container { align-self: flex-start; }
			${OLD_TOP} .product-form__quantity > :not(.quantity-custom-container) { width: 100%; }
		}
	`;
	document.head.appendChild(style);

	const oldTop = document.querySelector(OLD_TOP);
	if (!oldTop) return;
	setGiftBoxTitle();
	new MutationObserver(setGiftBoxTitle).observe(oldTop, { childList: true, subtree: true, characterData: true });
}

function testCode() {
	// The v1 visual change (old top section) is applied in <head> by snippets/air-12-pdp-top.liquid.
	realLog(
		'%cAIR-12 | Old top section on the new PDP',
		"color: white; background-color:#202621; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;",
	);
	styleOldTopGiftBox();
}

if (window.AIR12 && window.AIR12.variant !== 'v1') {
	placeGiftBoxInNewTop();
	new MutationObserver(placeGiftBoxInNewTop).observe(document.body, { childList: true, subtree: true });
}

// --->  MANUAL A/B TEST REPORTING <---
(function () {
	const test = window.AIR12;

	// No assignment: not the airdog-pdp template, or outside the device targeting.
	if (!test || !test.targeted) {
		realLog('Test skipped: Does not meet URL or Device targeting rules.');
		return;
	}

	if (!test.preview) {
		const testId = test.testId;
		const cookieName = test.cookieName;
		const variant = test.variant;

		// =========================================================================
		// ---> SEND DIRECTLY TO GA4
		// =========================================================================
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}

		gtag('set', 'user_properties', {
			[cookieName]: variant,
		});

		// No debug_mode here: GA4 treats the parameter as "debug" whenever it's present, even
		// when false, which keeps live events out of standard reports.
		gtag('event', 'experiment_impression', {
			experiment_id: testId,
			experiment_variant: variant,
			send_to: 'G-Y4VGNLBJPF',
		});
		// =========================================================================

		if (variant === 'v1') {
			realLog('MANUAL TEST: Variation active');
			testCode();
		} else {
			realLog('MANUAL TEST: Control active');
		}

		// Send the page view goal (if you still have a separate tracker looking for gbEvents)
		window.gbEvents.push('Page View');

		// Only if a quick checkout tracker exists on the page (it isn't defined in this theme).
		if (typeof window.initQuickCheckoutTracking === 'function') {
			if (document.readyState === 'complete') {
				window.initQuickCheckoutTracking();
			} else {
				window.addEventListener('load', window.initQuickCheckoutTracking);
			}
		}
	} else if (test.variant === 'v1') {
		realLog('%cPreview mode ACTIVE', "color: #F7F631; background-color:black; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;");
		testCode();
	}
})();

})();
